export const AGENDA_ACTIONS = {
    GET: 'GET_AGENDA',
    GET_SINGLE: 'GET_SINGLE_AGENDA',
    GET_INDIVIDUALS: 'GET_AGENDA_INDIVIDUALS',
    ADD: 'ADD_AGENDA',
    REMOVE: 'REMOVE_AGENDA',
    SUCCESS: 'SUCCESS_AGENDA',
    ERROR: 'ERROR_AGENDA',
    CLEAN: 'CLEAN_AGENDA',
    GET_STATUS: 'GET_AGENDA_STATUS_LIST',
    GET_ATTACHMENTS: 'GET_AGENDA_ATTACHMENTS',
    ADD_ATTACHMENTS: 'ADD_AGENDA_ATTACHMENTS',
    REMOVE_ATTACHMENTS: 'REMOVE_AGENDA_ATTACHMENTS'
}